import { DefaultService } from '@/services/DefaultService';

export default class ProdutoQtdePrecoService extends DefaultService {
  constructor(http, router, env) {
    super(http, router, env);
  }

  findAllVendas(column, order, page, limit, situacao, idcliente, ...params) {
    return this._http.get(encodeURI(`${this._env}/ven/cliente/produtoqtdepreco.json?page=${page}&limit=${limit}&column=${column}&order=${order}&situacao=${situacao}&idcliente=${idcliente}&param=${params}`), this._headers).then(res => {
      return res.body;
    }, err => {
      this.verifyError(err);
      throw new Error('Problema ao realizar função FindAll em ProdutoQtdePrecoService');
    });
  }

  findAllAgro(column, order, page, limit, situacao, idcliente, ...params) {
    return this._http.get(encodeURI(`${this._env}/agro/cliente/produtoqtdepreco.json?page=${page}&limit=${limit}&column=${column}&order=${order}&situacao=${situacao}&idcliente=${idcliente}&param=${params}`), this._headers).then(res => {
      return res.body;
    }, err => {
      this.verifyError(err);
      throw new Error('Problema ao realizar função FindAll em ProdutoQtdePrecoService');
    });
  }

  updateSituacao(produtoqtdepreco, ) {
    return this._http.post(`${this._env}/cliente/produtoqtdepreco/updatesituacao`, produtoqtdepreco, this._headers).then(res => {
      return res.body;
    }, err => {
      this.verifyError(err);
      throw err;
    });
  }

  loadEmpresas(idCliente) {
    return this._http.get(encodeURI(`${this._env}/ven/cliente/produtoqtdepreco/loadempresas.json?idcliente=${idCliente}`), this._headers).then(res => {
      return res.body;
    }, err => {
      this.verifyError(err);
      throw new Error('Problema ao realizar função loadEmpresas em ProdutoQtdePrecoService');
    });
  }

  loadTabelasPreco(idCliente, idempresa) {
    return this._http.get(encodeURI(`${this._env}/ven/cliente/produtoqtdepreco/loadtabelaspreco.json?idcliente=${idCliente}&idempresa=${idempresa}`), this._headers).then(res => {
      return res.body;
    }, err => {
      this.verifyError(err);
      throw new Error('Problema ao realizar função loadTabelasPreco em ProdutoQtdePrecoService');
    });
  }

  loadProdutos(idempresa, idTabelaPreco, search) {
    return this._http.get(encodeURI(`${this._env}/ven/cliente/produtoqtdepreco/loadprodutos.json?idempresa=${idempresa}&idtabelapreco=${idTabelaPreco}&search=${search}`), this._headers).then(res => {
      return res.body;
    }, err => {
      this.verifyError(err);
      throw new Error('Problema ao realizar função loadProdutos em ProdutoQtdePrecoService');
    });
  }

  save(descontoQuantidade, contexto = 'ven'){
    return this._http.post(`${this._env}/${contexto}/cliente/produtoqtdepreco`, descontoQuantidade, this._headers).then(res => {
      return res.body;
    }, err => {
      this.verifyError(err);
      throw err;
    });
  }

  loadDescontos(idcliente) {
    return this._http.get(`${this._env}/cliente/${idcliente}/produtoqtdepreco`, this._headers).then(res => {
      return res.body;
    }, err => {
      this.verifyError(err);
      throw err;
    });
  }

  loadProdutosDisponiveis(idcliente, page, limit, q) {
    return this._http.get(`${this._env}/cliente/${idcliente}/available-produtoqtdepreco?page=${page}&limit=${limit}&param=${q}`, this._headers).then(res => {
      return res.body;
    }, err => {
      this.verifyError(err);
      throw err;
    });
  }

  saveDesconto(desconto) {
    return this._http.post(`${this._env}/product/produtoqtdepreco`, desconto, this._headers).then(res => {
      return res.body;
    }, err => {
      this.verifyError(err);
      throw err;
    });
  }

  delDesconto(idprodutoqtdepreco) {
    return this._http.delete(`${this._env}/product/produtoqtdepreco/${idprodutoqtdepreco}`, this._headers).then(res => {
      return res.body;
    }, err => {
      this.verifyError(err);
      throw err;
    });
  }
}